import { Col, Divider, Row } from "antd";
import { BsCameraFill } from "react-icons/bs";
import { RiEditLine } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import ChangePasswordModal from "../../Modals/ChangePasswordModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutModal from "../../Modals/LogoutModal";
import { useDispatch, useSelector } from "react-redux";
import { FaStar } from "react-icons/fa";
import { UPLOADS_URL } from "../../config/constants/api";

const Setting = () => {
  const [passwordModal, setPasswordModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const userData = useSelector((state) => state.user.userData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div>
      <Row justify="center" className="py-16 max-sm:py-8">
        <Col md={20} sm={22} xs={22}>
          <div className="relative flex items-center">
            <h3 className="font-tavi text-4xl max-sm:text-2xl text-customBlack absolute left-1/2 transform -translate-x-1/2">
              Settings
            </h3>
            <button className="absolute right-0 p-2 bg-white shadow-md rounded-md">
              <RiEditLine
                size={24}
                onClick={() => {
                  navigate("/editProfile");
                }}
              />
            </button>
          </div>
          <Row justify="center">
            <Col md={12} sm={22} xs={22}>
              <div className="bg-white px-8 rounded-lg shadow-lg w-full mt-8 py-4">
                <div className="flex flex-col justify-center items-center">
                  <img
                    src={UPLOADS_URL + userData?.image}
                    editProfile
                    alt="profile"
                    style={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                  <div className="flex justify-center items-center p-2 bg-customGold rounded-full mt-[-20px] ml-[50px]">
                    <BsCameraFill size={16} className="text-white" />
                  </div>
                  <h6>{`${
                    userData?.firstName?.charAt(0).toUpperCase() +
                    userData?.firstName?.slice(1)
                  } ${
                    userData?.lastName?.charAt(0).toUpperCase() +
                    userData?.lastName?.slice(1)
                  }`}</h6>
                </div>
                <br />
                <Divider />
                <div className="flex justify-between items-center my-4">
                  <div className="text-center">
                    <p className="font-euclid text-customGray text-sm font-bold max-sm:text-xs">
                      50+
                    </p>
                    <p className="font-euclid text-customGray text-sm font-bold max-sm:text-xs">
                      Rides
                    </p>
                  </div>
                  <Divider
                    type="vertical"
                    style={{ height: "50px", border: "1px solid #e3e3e3e0" }}
                  />
                  <div className="text-center">
                    <p className="font-euclid flex text-customGray text-sm font-bold max-sm:text-xs items-center gap-2">
                      <FaStar color="#FDA701" className="inline text-lg" />
                      5.0{" "}
                    </p>
                    <p className="font-euclid text-customGray text-sm font-bold max-sm:text-xs">
                      Rating
                    </p>
                  </div>
                  <Divider
                    type="vertical"
                    style={{ height: "50px", border: "1px solid #e3e3e3e0" }}
                  />
                  <div className="text-center">
                    font-bold
                    <p className="font-euclid text-customGray text-sm font-bold max-sm:text-xs">
                      4.2
                    </p>
                    <p className="font-euclid text-customGray text-sm font-bold max-sm:text-xs">
                      Years
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <Divider />
              </div>
              <h5 className="font-tavi text-center pb-6 pt-10 text-2xl text-black mb-8 max-sm:text-lg font-semibold">
                Personal Profile
              </h5>
              <div className="bg-white px-8 rounded-lg shadow-lg w-full py-2 mt-6">
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        First Name
                      </p>
                    </div>
                  </div>
                  {userData?.firstName}
                </div>
                <Divider />
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Last Name
                      </p>
                    </div>
                  </div>
                  {userData?.lastName}
                </div>
                <Divider />
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Email Address
                      </p>
                    </div>
                  </div>
                  {userData?.email}
                </div>
                <Divider />
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Phone Number
                      </p>
                    </div>
                  </div>
                  {userData?.phone}
                </div>
              </div>
              <h5 className="font-tavi text-center pb-6 pt-10 text-2xl text-black mb-8 max-sm:text-lg font-semibold">
                Business Profile
              </h5>
              <div className="bg-white px-8 rounded-lg shadow-lg w-full py-2 mt-6">
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Business Name
                      </p>
                    </div>
                  </div>
                  {userData?.businessProfile?.businessName
                    ? userData?.businessProfile?.businessName
                    : "-"}
                </div>
                <Divider />

                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Business Email
                      </p>
                    </div>
                  </div>
                  {userData?.businessProfile?.businessEmail
                    ? userData?.businessProfile?.businessEmail
                    : "-"}{" "}
                </div>
                <Divider />
                <div className="flex justify-between items-center my-6">
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Business Phone
                      </p>
                    </div>
                  </div>
                  {userData?.businessProfile?.businessPhone
                    ? userData?.businessProfile?.businessPhone
                    : "-"}
                </div>
              </div>
              <Divider />
              <div className="bg-white px-8 rounded-lg shadow-lg w-full mt-8 py-4">
                <div
                  className="flex justify-between items-center my-6"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPasswordModal(true);
                  }}
                >
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Change Password
                      </p>
                    </div>
                  </div>
                  <IoIosArrowForward />
                </div>
                <Divider />
                <div
                  className="flex justify-between items-center my-6"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setLogoutModal(true);
                  }}
                >
                  <div className="flex justify-center items-center">
                    <div className="flex flex-col items-start justify-center ml-2">
                      <p className="font-euclid text-md font-semibold text-customLightGray max-sm:text-[10px]">
                        Logout
                      </p>
                    </div>
                  </div>
                  <IoIosArrowForward />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {passwordModal && (
        <ChangePasswordModal
          passwordModal={passwordModal}
          setPasswordModal={setPasswordModal}
        />
      )}
      {logoutModal && (
        <LogoutModal
          logoutModal={logoutModal}
          setLogoutModal={setLogoutModal}
        />
      )}
    </div>
  );
};

export default Setting;
